import { Switch } from 'antd';
import { UpdateEntity } from '../../containers/updateEntity';
import { formatDate } from '@arivaa-react/helpers/date-util';
import { Crud } from '../../containers/crud/crud';
import { Table } from '../../containers/crud/table';
import { translate } from '../../../localization';
import { useCrudData } from '../../containers/crud/crudContext';
import { PortfolioForm } from './form';
import { WebCrud } from '../../containers/crud/webCrud';
import { ViewPostRowAction } from '../../containers/viewPostRowAction';
export default function Portfolio() {
  const { refresh } = useCrudData();
  return (
    <WebCrud api="portfolio" FormComponent={PortfolioForm}>
      <Crud.Header title="Portfolio">
        <Crud.Header.Actions.Common>
          <Crud.Header.Actions.Add
            modalProps={{
              className: 'large',
            }}
          />
        </Crud.Header.Actions.Common>
      </Crud.Header>
      <Crud.Search
        fields={[
          {
            name: 'title',
            type: 'text',
            inputProps: {
              placeholder: translate('common.title'),
            },
          },
          {
            name: 'shortDescription',
            type: 'text',
            inputProps: {
              placeholder: translate('portfolio.shortDescription'),
            },
          },
          {
            label: translate('portfolio.published'),
            name: 'published',
            type: 'custom',
            Component: Switch,
          },
          {
            label: translate('portfolio.featured'),
            name: 'featured',
            type: 'custom',
            Component: Switch,
          },
        ]}
      ></Crud.Search>
      <Crud.Table
        actions={[
          ...Table.RowActions.Common,
          Crud.Table.RowActions.DuplicateRecordWithForm,
          () => <ViewPostRowAction postType={'project'} />,
        ]}
        columns={[
          {
            title: translate('common.title'),
            dataIndex: 'title',
          },
          {
            title: translate('portfolio.featured'),
            dataIndex: 'featured',
            render: (_, record) => {
              return (
                <UpdateEntity
                  getChildren={({ loading, updateEntity }) => {
                    return (
                      <Switch
                        loading={loading}
                        checked={record.featured}
                        onChange={async (checked) => {
                          await updateEntity({ featured: checked });
                          refresh();
                        }}
                      />
                    );
                  }}
                />
              );
            },
          },
          {
            title: translate('portfolio.published'),
            dataIndex: 'published',
            render: (_, record) => {
              return (
                <UpdateEntity
                  getChildren={({ loading, updateEntity }) => {
                    return (
                      <Switch
                        loading={loading}
                        checked={record.published}
                        onChange={async (checked) => {
                          await updateEntity({ published: checked });
                          refresh();
                        }}
                      />
                    );
                  }}
                />
              );
            },
          },
          {
            title: translate('portfolio.createdAt'),
            dataIndex: 'createdAt',
            render: (text) => {
              return formatDate(text);
            },
          },
        ]}
      >
        <Crud.Table.TableActions.Common />
        <Crud.Table.Header>
          <Crud.Table.BulkRowActions.Common />
        </Crud.Table.Header>
      </Crud.Table>
    </WebCrud>
  );
}
